import { Link } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function AuditBanner() {
  return (
    <section
      data-testid="audit-banner"
      className="relative overflow-hidden border-b border-white/10 bg-obsidian"
    >
      <div className="absolute inset-0 bg-dot opacity-40" />
      <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-neon-green/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 h-72 w-72 rounded-full bg-neon-cyan/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-24">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="border border-neon-green/30 bg-carbon/70 backdrop-blur-md p-8 lg:p-12 flex flex-col lg:flex-row gap-8 items-start lg:items-center"
        >
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 chip text-neon-green border border-neon-green/40 px-2.5 py-1">
              <Zap size={12} /> free.lead_magnet
            </div>
            <h3 className="mt-4 font-display font-black text-3xl md:text-4xl lg:text-5xl text-white leading-[0.95] tracking-tighter">
              Free{" "}
              <span className="text-glow-green text-neon-green">Modernization Risk Audit</span>
              .<br className="hidden md:block" /> 60 seconds. Zero sales pitch.
            </h3>
            <p className="mt-5 max-w-2xl text-white/70 text-sm md:text-base leading-relaxed">
              Answer 5 questions about your legacy programme. Get an instant,
              personalised risk score with findings and recommendations, using
              the same framework we use for our enterprise engagements.
            </p>
          </div>
          <Link
            to="/audit"
            data-testid="audit-banner-cta"
            className="group inline-flex items-center gap-2 bg-neon-green text-obsidian px-7 py-4 text-sm font-mono font-bold uppercase tracking-widest hover:shadow-[0_0_48px_rgba(0,255,65,0.7)] hover:-translate-y-0.5 transition-all whitespace-nowrap"
          >
            Start Audit
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
